import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export function EmptyState({ icon: Icon, title, description, actionLabel, onAction, testId = "empty-state" }) {
    return (
        <div
            className="flex flex-col items-center justify-center rounded-xl border border-dashed bg-card px-6 py-12 text-center"
            data-testid={testId}
        >
            {Icon && (
                <div className="mb-3 rounded-full bg-muted p-3 text-muted-foreground">
                    <Icon className="h-5 w-5" />
                </div>
            )}
            <div className="text-sm font-semibold">{title}</div>
            {description && (
                <p className="mt-1 max-w-md text-xs text-muted-foreground">{description}</p>
            )}
            {actionLabel && onAction && (
                <Button
                    onClick={onAction}
                    size="sm"
                    className="mt-4 bg-secondary text-secondary-foreground hover:opacity-90"
                    data-testid={`${testId}-action`}
                >
                    <Plus className="mr-2 h-4 w-4" />
                    {actionLabel}
                </Button>
            )}
        </div>
    );
}
